import React from "react";
import {
  EuiPanel,
  EuiFlexGroup,
  EuiFlexItem,
  EuiText,
  EuiImage,
  EuiTitle,
  EuiSpacer,
} from "@elastic/eui";
import youtube from "../images/youtube.png";
import tiktok from "../images/tiktok.png";
import discord from "../images/discord.jpg";
import twitter from "../images/twitter.jpg";
import avatar from "../images/avatar.jpg";

export const Home: React.FC = () => {
  return (
    <div className={"App-content"}>
      <EuiFlexGroup direction="column" gutterSize="s">
        <EuiFlexItem grow={false}>
          <div className="brand-text">
            <span id="brand-pop">Pop</span>
            <span id="brand-si">si</span>
            <span id="brand-code">code</span>
          </div>
        </EuiFlexItem>
        <EuiFlexItem>
          <EuiPanel
            hasShadow={false}
            paddingSize="l"
            style={{ marginLeft: "17px", marginRight: "17px" }}
          >
            <EuiFlexGroup direction="column" alignItems="center" gutterSize="s">
              <EuiFlexItem>
                <EuiTitle size="l">
                  <h1>About me</h1>
                </EuiTitle>
              </EuiFlexItem>
              <EuiSpacer size="m" />
              <EuiFlexItem>
                <EuiImage
                  src={avatar}
                  size={"s"}
                  alt="avatar"
                  className="avatar"
                />
              </EuiFlexItem>
              <EuiSpacer size="m" />
              <EuiFlexItem>
                <EuiText>
                  <p>
                    Welcome to my corner of the web! Here I share my journey of
                    building apps, testing productivity challenges, and
                    exploring personal growth. I&apos;ve balanced a full-time
                    job with earning two master&apos;s degrees, taken a
                    sabbatical to rethink my career, and built side projects
                    along the way.
                  </p>
                  <p>
                    If you&apos;re interested in coding, self-improvement, or
                    building a career and life you enjoy — check out my Youtube
                    channel.
                  </p>
                </EuiText>
              </EuiFlexItem>
            </EuiFlexGroup>
          </EuiPanel>
        </EuiFlexItem>
        <EuiFlexItem>
          <EuiPanel hasShadow={false} color="transparent">
            <EuiFlexGroup gutterSize="m">
              <EuiFlexItem grow={false}>
                <a href="https://www.youtube.com/@popsicode">
                  <EuiImage
                    src={youtube}
                    size={"s"}
                    alt="youtube"
                    className="logo"
                  />
                </a>
              </EuiFlexItem>
              <EuiFlexItem grow={false}>
                {/* <a href="https://www.youtube.com/@popsicode"> */}
                <EuiImage
                  src={discord}
                  size={"s"}
                  alt="discord"
                  className="logo"
                />
                {/* </a> */}
              </EuiFlexItem>
              <EuiFlexItem grow={false}>
                {/* <a href="https://www.youtube.com/@popsicode"> */}
                <EuiImage
                  src={tiktok}
                  size={"s"}
                  alt="tiktok"
                  className="logo"
                />
                {/* </a> */}
              </EuiFlexItem>
              <EuiFlexItem grow={false}>
                {/* <a href="https://www.youtube.com/@popsicode"> */}
                <EuiImage
                  src={twitter}
                  size={"s"}
                  alt="twitter"
                  className="logo"
                />
                {/* </a> */}
              </EuiFlexItem>
            </EuiFlexGroup>
          </EuiPanel>
        </EuiFlexItem>
      </EuiFlexGroup>
    </div>
  );
};

Home.displayName = "Home";
